import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { StaffEditPage } from '../edit/staff-edit'; 
import { StaffAction } from '../../../actions/staff.action';
import { AbstractPage } from '../../_com/abstract-page';

/**
 * Generated class for the StaffDetailPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-staff-detail',
  templateUrl: 'staff-detail.html',
})
export class StaffDetailPage extends AbstractPage {

  constructor(
  	public navCtrl: NavController, 
  	public navParams: NavParams,
    private staffAction:StaffAction,
  	) {
  	super();
  }

  data = {}

  ionViewDidLoad() {
    this.data = this.navParams.data.User;
  }

  ionViewDidEnter() {
    this.refresh();
  }

  /**
   * リフレッシュ
   */
  refresh(){
    this.staffAction.getOne({id:this.data["id"]}).subscribe((data)=>{
      this.data = data.data.User;
    })
  }

  /**
   * 編集処理
   */
  edit(){

    this.navCtrl.push(StaffEditPage, this.data);

    // var self = this;
    // let modal = this.modalController.create(StaffEditPage, this.data);
    // modal.present();
    // modal.onDidDismiss((data)=>{
    //   if(data["update"]){
    //     self.refresh();
    //   }
    // });
  }
}



// WEBPACK FOOTER //
// ./src/pages/staff/detail/staff-detail.ts